import React , {useState , useEffect} from 'react'
import Breadcrumbs from '../../common/breadcrumb/Breadcrumbs'
import { getOperater , getDataReports ,getDataReportsAllexcel ,paymentEnquirybbps } from '../../api/login/Login'
import { useParams } from 'react-router-dom'
import CustomInputField from '../../common/CustomInputField'
import { Formik, Form, Field } from 'formik';
import { ToastContainer } from 'react-toastify'
import { message, Pagination ,Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import Loadar from '../../common/loader/Loader'
import * as XLSX from 'xlsx'; 




const CommonBBPSReport = ({ breadCrumbsTitle }) => {
    const param = useParams();
    const [operators, setOperators] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
      const [data, setData] = useState(null);
      const [loading , setLoading] = useState(false)
    const [formKey, setFormKey] = useState(0);
    const [resetKey , setResetKey] = useState(false)
    const defaultInitialValues = {
        operator_id: '',
        member_code: '',
        name: '',
        start_date: '',
        end_date: '',
        category_id: param.id || '',
        user_id: '',
        biller_id: '',
        member_name: '',
        txn_id: '',
    };
    const resetValues = {
        operator_id: '',
        member_code: '',
        name: '',
        start_date: '',
        end_date: '',
        category_id: param.id || '',
        user_id: '',
        biller_id: '',
        member_name: '',
        txn_id: '',
    };
    const [initialValues, setInitialValues] = useState(defaultInitialValues);
 

    

        useEffect(() => {
            const fetchOperators = async () => {
                try {
                    const res = await getOperater(param?.id);
                    setOperators(res?.data || []);
                } catch (error) {
                    console.error("Error fetching operators:", error);
                }
            };
            fetchOperators();
        }, [param?.id]);

        const handleReset = (resetForm) => {
            resetForm();
            setInitialValues(resetValues);
            setFormKey(prev => prev + 1); 
            setCurrentPage(1)
            setResetKey((pre)=>!pre)
            // getDmtTxnData(0); 
        };

        const handleSubmit = (values) => {
            console.log("fire")
            setCurrentPage(1)
            setInitialValues(values)
            setResetKey((pre)=>!pre)
            // Add your API call here
        };

        const onChangeVal = (page) => {
            setResetKey((pre)=>!pre)
            setCurrentPage(page);
           
        };

  const getData = async () => {
    setLoading(true);
    try {
      const res = await getDataReports({ 
        ...initialValues, 
        page: currentPage-1, 
        category_id: param.id 
      });
      if (res && res.data) {
        setData(res);
      } else {
        setData(null);
        message.info('No data available');
      }
    } catch (error) {
      console.error("Error fetching DMT transaction data:", error);
      message.error('Failed to fetch transaction data. Please try again.');
      setData(null);
    } finally {
      setLoading(false);
    }
  };


    const downloadExcel = async () => {
      try {
        setLoading(true);
        const res = await getDataReportsAllexcel({
          ...initialValues,
          category_id: param.id
        });
  
        if (res && res.data && res.data.length > 0) {
            const dataForExcel = res.data.map((item, i) => ({
                "Sr. No": i + 1,
                "Date / Time": item?.createdAt,
                "Name": item?.name,
                "Retailer code": item?.refer_id,
                "Retailer Mobileno": item?.retailer_mobile,
                "Transaction ID": item?.txn_id,
                "Ref ID": item?.refId,
                "Mobile Number": item?.ca_num,
                "Operator name": item?.operator_name,
                "Operator ID": item?.biller_id,
                "Transction  Reference ID": item?.txnReferenceceId,
                "Updated ": item?.updatedAt,
                "Status Updated ": item?.status_update_time,
                "Amount": item?.amount,
                "Opening Balance": item?.open_bal,
                "Clsing Balance":item?.close_bal,
                "Status":  item?.status === 2 ? 'Success' :
                item?.status === 1 ? 'Pending' :
                item?.status === 3 ? 'Failed' :
                item?.status === 4 ? 'Refund' :
                'Unknown',
                'Distributor Name': item.distributor_name || "",
                'Distributor Commission': item.distributor_commission || "",
                'Super Distributor Name': item.master_dist_name || "",
                'Super Distributor Commission': item.master_dist_commission || "",
                'Distributor Contact': item.distributor_mobile || "",
                'Super Distributor Contact': item.master_dist_mobile || "",
                'Distributor Refer Id': item.distributor_refer_id || "",
                'Super Distributor Refer Id': item.master_dist_refer_id || "",
              }));
  
          const ws = XLSX.utils.json_to_sheet(dataForExcel);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, " Report");
          XLSX.writeFile(wb, `Report ${new Date().toLocaleDateString()}.xlsx`);
        } else {
          message.error('No data available to export!');
        }
      } catch (error) {
        console.error("Error downloading Excel:", error);
        message.error('Failed to download Excel. Please try again.');
      } finally {
        setLoading(false);
      }
    };

      const responseEnquiry = async (id) => {
        setLoading(true); // Start loader before API call
        try {
            const res = await paymentEnquirybbps(id);
            if (res?.data?.statusCode == "200") {
                message.success(res?.data?.message || "Operation successful");
                
            } else if (res?.data?.statusCode == "300") {
                message.info(res?.data?.message || "Transaction requires attention");
               
            } else {
                message.error(res?.message || res?.data?.message || "Operation failed");
                
            }
        } catch (error) {
            console.error("Error in payment enquiry:", error);
            message.error("An error occurred while processing your request");
        } finally {
            setResetKey((pre)=>!pre)
            setLoading(false); 
        }
    };


  useEffect(()=>{
    getData()
  },[resetKey , currentPage])
  return (
    <>
    { loading && <Loadar/> }
      <ToastContainer />

    
    <Breadcrumbs breadCrumbsTitle={breadCrumbsTitle} />
    
    {/* // Filter Option // */}
    <div className="row m-4">
            <div className="col-xl-12">
                <div className="card">
                    <div className="card-body p-0">
                        <div className="table-responsive active-projects style-1">
                            <div className="tbl-caption tbl-caption-2">
                                <h4 className="heading mb-0"><b>{breadCrumbsTitle.title_2} Search</b></h4>
                            </div>
                            <Formik
                                  key={formKey}
                                  initialValues={initialValues}
                                  onSubmit={handleSubmit}
                                enableReinitialize
                            >
                                {({ errors, touched, resetForm }) => (
                                    <Form className="tbl-captionn">
                                        <div className="row">
                                            <div className="col-xl-4 mb-3">
                                                <Field
                                                    as={CustomInputField}
                                                    type="date"
                                                    name="start_date"
                                                    placeholder="Start Date"
                                                    hasError={touched.start_date && errors.start_date}
                                                    errorMsg={errors.start_date}
                                                />
                                            </div>
                                            <div className="col-xl-4 mb-3">
                                                <Field
                                                    as={CustomInputField}
                                                    type="date"
                                                    name="end_date"
                                                    placeholder="End Date"
                                                    hasError={touched.end_date && errors.end_date}
                                                    errorMsg={errors.end_date}
                                                />
                                            </div>
                                            <div className="col-xl-4 mb-3">
                                                <Field as="select" className="form-select" name="operator_id">
                                                    <option value="">Select Operator</option>
                                                    {operators.map((op) => (
                                                        <option key={op._id} value={op._id}>
                                                            {op.name}
                                                        </option>
                                                    ))}
                                                </Field>
                                            </div>
                                            <div className="col-xl-4 mb-3">
                                                <Field
                                                    as={CustomInputField}
                                                    type="text"
                                                    name="member_code"
                                                    placeholder="Member Code"
                                                    hasError={touched.member_code && errors.member_code}
                                                    errorMsg={errors.member_code}
                                                />
                                            </div>
                                            <div className="col-xl-4 mb-3">
                                                <Field
                                                    as={CustomInputField}
                                                    type="text"
                                                    name="member_name"
                                                    placeholder="Member Name"
                                                    hasError={touched.member_name && errors.member_name}
                                                    errorMsg={errors.member_name}
                                                />
                                            </div>
                                            <div className="col-xl-4 mb-3">
                                                <Field
                                                    as={CustomInputField}
                                                    type="text"
                                                    name="txn_id"
                                                    placeholder="Transaction ID"
                                                    hasError={touched.txn_id && errors.txn_id}
                                                    errorMsg={errors.txn_id}
                                                />
                                            </div>
                                            <div className="col-xl-4 mb-3">
                                                <Field
                                                    as={CustomInputField}
                                                    type="text"
                                                    name="biller_id"
                                                    placeholder="Biller ID"
                                                    hasError={touched.biller_id && errors.biller_id}
                                                    errorMsg={errors.biller_id}
                                                />
                                            </div>
                                            <div className="col-lg-12 col-md-12">
                                                <div className="d-flex justify-content-start">
                                                    <button className="btn btn-primary me-2" type="submit">
                                                        <i className="fas fa-search"></i> Search
                                                    </button>
                                                    <btn className="btn btn-secondary" type="button" onClick={() => handleReset(resetForm)}>
                                                        <i className="fas fa-refresh"></i> Reset
                                                    </btn>
                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {/* // filter option end here  */}


    {/* // table section  */}
    {data?.data?.length > 0 ? (
        <>
         <section className="ListDistributer exppdf">
                <div className="row m-4">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                 <div className="p-3">
                                    <h3 className="totalAmountstyle">Total Amount: <b>{data?.totalAmount || 0}</b></h3>
                                </div>
                                <div className="table-responsive active-projects style-1">
                                    <div className="tbl-caption">
                                        <h4 className="heading mb-0"><b>{breadCrumbsTitle.title_2} List</b></h4>
                                        <div className='d-flex'>
                                           
                                            <button onClick={downloadExcel} className='btn btn-primary border border-white'> <DownloadOutlined /> Download Excel</button>
                                        </div>
                                      

                                    </div>
                                    <div id="empoloyees-tblwrapper_wrapper" className="dataTables_wrapper no-footer"> 
    <table id="table-to-xls" className="table dataTable no-footer" role="grid" aria-describedby="empoloyees-tblwrapper_info">
        <thead>
            <tr role="row">
                <th>Sr. No</th>
                <th>Date / Time</th>
                <th>Name</th>
                <th>Retailer code</th>
                <th>Retailer Mobile No</th>
                <th>Transaction ID</th>
                <th>Ref ID</th>
                <th>CA Number</th>
                <th>Operator name</th>
                <th>Biller ID</th>
                
                <th>Transaction Reference ID</th>
                <th>Updated</th>
                <th>Status Updated</th>
                <th>Amount</th>
                <th>Opening Balance</th>
                <th>Closeing Balance</th>
                <th>Status</th>
                
                <th>Distributor Name</th>
                {/* <th>Distributor Commission</th> */}
                <th>Super Distributor Name</th>
                {/* <th>Super Distributor Commission</th> */}
                <th>Distributor Contact</th>
                <th>Super Distributor Contact</th>
                <th>Distributor Refer Id</th>
                <th>Super Distributor Refer Id</th>
            </tr>
        </thead>
        <tbody>
            {data?.data?.map((item, i) => (
                <tr key={i} role="row" className="odd">
                    <td>{i + 1}</td>
                    <td>{item?.createdAt}</td>
                    <td>{item?.name}</td>
                    <td>{item?.refer_id}</td>
                    <td>{item?.retailer_mobile}</td>
                    <td>{item?.txn_id}</td>
                    <td>{item?.refId}</td>
                    <td>{item?.ca_num}</td>
                    <td>{item?.operator_name}</td>
                    <td>{item?.biller_id}</td>
                    <td>{item?.txnReferenceId}</td>
                    <td>{item?.updatedAt}</td>
                    <td>{item?.status_update_time}</td>
                    <td>{item?.amount}</td>
                    <td>{item?.open_bal}</td>
                    <td>{item?.close_bal}</td>
                    <td>
                    {item?.status === 1 && (
                            <button className="btn btn-warning">Pending</button>
                        )}
                        {item?.status === 2 && (
                            <button className="btn btn-success">Success</button>
                        )}
                        {item?.status === 3 && (
                            <button className="btn btn-danger">Failed</button>
                        )}
                         {item?.status === 4 && (
                            <button className="btn btn-light">Refund</button>
                        )}
                    </td>
                    <td>{item?.distributor_name || ""}</td>
                    {/* <td>{item?.distributor_commission || ""}</td> */}
                    <td>{item?.master_dist_name || ""}</td>
                    {/* <td>{item?.master_dist_commission || ""}</td> */}
                    <td>{item?.distributor_mobile || ""}</td>
                    <td>{item?.master_dist_mobile || ""}</td>
                    <td>{item?.distributor_refer_id || ""}</td>
                    <td>{item?.master_dist_refer_id || ""}</td>
                    <td> {item?.enqNumLog}</td>
                    <td><Button variant="outline-primary" onClick={() => responseEnquiry(item.txn_id)}
                              disabled={loading || item?.status !== 1}>
                            Enquiry
                            </Button></td>
                </tr>
            ))}
        </tbody>
    </table>
</div>

                                </div>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <div className="dataTables_info" id="empoloyees-tblwrapper_info" role="status" aria-live="polite">
                                        Total {data?.totalCount} entries
                                    </div>
                                    <div className="dataTables_paginate paging_simple_numbers" id="empoloyees-tblwrapper_paginate">
                                        <Pagination
                                            /* showSizeChanger
                                            onShowSizeChange={''} */

                                            // defaultCurrent={1}
                                            // onChange={onChangeVal}
                                            total={data?.totalCount}
                                            current={currentPage}
                                            onChange={onChangeVal}
 
                                        />
                                    </div>
                                </div>
                            </div>
                           
                        </div>

                    </div>

                </div >
            </section>
        </>
        ) : (
          <div className="text-center mt-4">
            <h3>No data available</h3>
          </div>
        )}
       {/* // table section  */}
    </>
  )
}

export default CommonBBPSReport